import _ from 'lodash';
import { checkModalSubscription } from '../../helper';

export const getSelectedValue = (subscriptionTypes, value) => {
  if (_.isNull(value) || _.isUndefined(value)) {
    return value;
  }

  const findSubscriptionType = subscriptionTypes.find((type) => Number(type.id) === Number(value));
  if (findSubscriptionType) {
    return {
      label: findSubscriptionType.name,
      value: findSubscriptionType.id,
    }
  }
  return null;
};

/**
 * Проверяет, если удален провайдер у Subscription услуги
 * Присылается Mode = 0 (Manual)
 */
export const checkIsDeleteServiceSubscriptionProvider = (modal) => {
  const isSubscription = checkModalSubscription(modal);
  const isEdit = !!modal?.id;
  const isModeManual = Number(modal?.mode) === 0;

  return isSubscription && isEdit && isModeManual;
}

export const getSelectOptions = (serviceTypes) => {
  if (serviceTypes) {
    return serviceTypes
      .filter((type) => {
        /**
         * Проверяем типы:
         * subscription
         * subscription reselling
         *
         * (не показываем)
         */
        if (type.id === 100 || type.id === 101) {
          return false;
        }
        return type.shown;
      })
      .map((type) => ({
        label: type.name,
        value: type.id,
        ...type,
      }))
  }
  return [];
};
